<div class="l-main" role="main">
	<div class="l-container">

		<div class="l-content">


			<div class="panel-pane bg-transparent align-center">
				<ul class="list--pipe">
					<li><a href="">Visit the UC Davis directory</a></li>
				</ul>
			</div>

			<div class="panel-pane box">
        <!--  <div class="panel-pane box"> -->
          <!-- ********** Main content ********** -->                                                  
                                                                                             
						<div id="main_section">                                                          
                                                                                             
							<!-- Center column (primary content) -->                                       
                                                                                             
							<div id="center_column">                                                       
                                                                                             
								<div id="center_column_inner_wrap">  
							
									<!-- Search LDAP -->                                                       
								<!--	<form                                                                      
										action="http://directory.ucdavis.edu/search/directory_results.shtml"         
										method="get" id="search_people_form">                                    
										<div id="search_form">                                                   
											<label for="search_text">Search:</label> <input type="text"            
												id="search_text" class="inputfield" name="filter" size="25"          
												maxlength="255" value="" /> <input type="submit" name="sa"           
												value="GO" class="inputsubmit" />                                    
										</div>                                                                   
									</form> 
-->									
									<!-- End search LDAP -->                                                   
                                                                                             
									<h2>Searching the Directory</h2>                                           
                                                                                             
									<p>                                                                        
                                                                                             
										To search by name, enter the person's full, last, or partial             
                                                                                             
										name. The search will return all names that match, contain, or           
                                                                                             
										sound like the name you enter. You may use the wildcard                  
                                                                                             
										&quot;*&quot; to match any part of the name. To find John                
                                                                                             
										Smith, you could enter &quot;john smith&quot;, &quot;j*                  
                                                                                             
										smith&quot;, &quot;j smith&quot;, &quot;john *&quot; or                  
                                                                                             
										&quot;smith&quot;. (<strong>Note: You must use the                       
                                                                                             
											wildcard &quot;*&quot; to search by first name only</strong>) The more 
                                                                                             
										specific your search, the fewer results are returned.                    
                                                                                             
									</p>                                                                       
                                                                                             
									<p>To search by e-mail address, enter the person's e-mail                  
                                                                                             
										address (jxsmith@ucdavis.edu) or mailID (jxsmith).</p>                   
                                                                                             
									<p>When searching by phone number, you may enter the                       
                                                                                             
										person's full (530-123-4567) or partial phone number (123-4567           
                                                                                             
										or 3-4567).</p>                                                          
                                                                                             
									<h2 id="dir_changes">Changing Directory Information</h2>                   
                                                                                             
									<p>Follow the instructions below to update your directory                  
                                                                                             
										information. Individuals designated as department approvers              
                                                                                             
										may also use this method to update directory information for             
                                                                                             
										individuals within their departments.</p>                                
                                                                                             
									<ol>                                                                       
                                                                                             
										<li>In the <strong>Search</strong> field above, enter the                
                                                                                             
											name of the person whose information you want to change.               
                                                                                             
										</li>                                                                    
                                                                                             
										<li>Click <strong>Go</strong>.                                           
                                                                                             
										</li>                                                                    
                                                                                             
										<li>Click on the <strong>Update this listing </strong>                   
                                                                                             
											link (next to the person's name).                                      
                                                                                             
										</li>                                                                    
                                                                                             
										<li>Log in using your login ID and Kerberos passphrase.</li>             
                                                                                             
										<li>On the edit page, you may make changes to any fields                 
                                                                                             
											accessible to you. To save your changes, click <strong>Submit          
                                                                                             
												Request</strong>.                                                    
                                                                                             
										</li>                                                                    
                                                                                             
									</ol>                                                                      
                                                                                             
									<p>Changes submitted will be posted once they have been                    
                                                                                             
										reviewed for accuracy and/or approved.</p>                               
                                                                                             
									<h2 id="vcard">vCard Information</h2>                                      
                                                                                             
									<p>vCard is a file format standard for personal data                       
                                                                                             
										interchange, specifically electronic business cards. They are            
                                                                                             
										often attached to e-mail messages, but can be exchanged in               
                                                                                             
										other ways, such as on the World Wide Web. They can contain              
                                                                                             
										name and address information, phone numbers, URLs, logos,                
                                                                                             
										photographs, and even audio clips. The vCard link helps users            
                                                                                             
										to minimize their efforts when adding a new contact to their             
                                                                                             
										contacts list within their own e-mail handler.</p>                       
                                                                                             
									<p>                                                                        
                                                                                             
										To download a vCard click on the <strong>Add listing                     
                                                                                             
											to your address book</strong> to the right of the vCard image.         
                                                                                             
									</p>                                                                       
                                                                                             
									<p>If your browser is configured to open vCard files with                  
                                                                                             
										your address book application the vCard will be loaded, if               
                                                                                             
										not, you can save the file to your desktop and open it with              
                                                                                             
										your address book program if it supports vCard.</p>                      
                                                                                             
									<!-- This item is required so the columns appear to be of equal length. -->
                                       
									<div class="clearer">&nbsp;</div>                                          
                                                                                             
								</div>                                                                       
                                                                                             
							</div>                                                                         
                                                                                             
							<!-- End center column -->                                                     
                                                                                             
						</div>                                                                           
                                                                                             
						<!-- ********** End main content ********** -->          


			</div>
		</div>
		<!--end .l-content-->

	</div>

</div>
<!--End role=main-->
<p class="privacy">
	<strong>Privacy Notice:</strong> This campus directory is the property
	of <a href="https://www.ucdavis.edu"><font size="3" color="navy">University
			of California, Davis.</font> </a> To protect the privacy of individuals listed
	herein, in accordance with the State of California Information
	Practices Act, this directory may not be used, rented, distributed, or
	sold for commercial purposes.
</p>